/**
 * Created by jv on 24/04/2018.
 */
import Shared from "Sources/shared";
import LanguageManager from "Sources/services/language-manager";
import utils from "Sources/utils/utils";
import FormValidator from "Sources/components/form-validator";
import ApplicationServices from "Sources/services/application-services";

// Styles
require("Styles/pages/marketing/contact.scss");

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();

  ContactPage.init();
});

let ContactPage = {};

((ContactPage) => {
  let contactFormValidator = null;

  ContactPage.init = function () {
    setUpEventListeners();
  };

  function setUpEventListeners() {
    contactFormValidator = new FormValidator({
      selector: "#contact-form",
      validateOnChange: true,
      rules: {
        name: {required: true},
        email: {required: true},
        message: {required: true}
      }
    });

    $("#contact-submit-btn").on("click", function (e) {
      let $this = $(this);
      let isValid = contactFormValidator.validate();

      if (isValid) {
        $this.prop("disabled", true).removeClass("loading").addClass("loading");

        let formData = contactFormValidator.getFormData();

        sendContactForm(formData.name, formData.email, formData.message)
          .then((data) => {
            $this.prop("disabled", false).removeClass("loading");

            Shared.Dialog.showMessageDialog({
              title: "contact.submit.success.dialog.title",
              message: "contact.submit.success.dialog.message",
              disposable: false,
              onConfirm: () => {
                contactFormValidator.clearForm();
                utils.redirect("/home");
              }
            });
          })
          .catch((err) => {
            $this.prop("disabled", false).removeClass("loading");

            Shared.Dialog.showMessageDialog({
              title: err.readableErrorTitle,
              message: err.readableErrorMessage
            });
          });
      }
    });
  }

  function sendContactForm(name, email, message) {
    return ApplicationServices.sendContactForm(name, email, message, LanguageManager.getCurrentLocale());
  }

})(ContactPage);



// WEBPACK FOOTER //
// ./app/js/entries/marketing/contact.js